<template>
    <div class="app auth d-flex flex-row">
        <div class="auth-layout d-flex flex-column align-content-between w-100">
            <div class="auth-header">
                <div class="container d-flex justify-content-start" style="max-width: 467px; margin: 0 auto;">
                    <router-link :to="{name:'login'}" class="btn btn-link p-0 m-0">
                        <img src="/static/img/sniezka_group.png" :alt="$t('[[[Śnieżka]]]')">
                    </router-link>
                </div>
            </div>
            <div class="container h-100 d-flex align-items-center">
                <div class="auth-form">
                    <router-view />
                </div>
            </div>
            <footer class="container auth-footer mt-auto">
                <div class="row text-white">
                    <div class="col-md-3">
                    </div>
                    <div class="col-md-3">
                    </div>
                </div>
            </footer>
        </div>
        <div v-if="$route.name !== 'acceptance-confirmation'" class="auth-sidebar ml-auto w-100">
            <img class="wortal-logo d-flex m-auto pb-5" src="/static/img/logo_inside_blue.png" :alt="$t('[[[Inside]]]')">
            <img class="img-fluid ideo-logo" src="/static/img/ideo_logo.png" :alt="$t('[[[Ideo]]]')" />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.app {
    min-height: 100vh;
    background: #FFFFFF;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
}
.copy {
    color: #FFFFFF;
    text-shadow: 1px 1px 5px #333;
}
</style>

<style lang="scss">
@import 'src/assets/scss/auth';
</style>
